import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  administrationRulesList: [],
  loadingAdministrationRules: false,
  settings: [],
  loadingSettings: false,
  error: undefined,
  totalElements: '',
};

const administrationSlice = createSlice({
  name: 'administration',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loadingAdministrationRules = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loadingAdministrationRules = false;
    },
    actionSettingsStart(state) {
      state.loadingSettings = true;
      state.error = undefined;
    },
    actionSettingsError(state, action) {
      state.error = action.payload;
      state.loadingSettings = false;
    },
    actionStopSettingsLoading(state) {
      state.loadingSettings = false;
      state.error = undefined;
    },
    fetchAllAdministrationRulesPageable(state, action) {
      state.administrationRulesList = action.payload.content;
      state.totalElements = action.payload.totalElements;
      state.error = undefined;
      state.loadingAdministrationRules = false;
    },
    fetchAllAdministrationRules(state, action) {
      state.administrationRulesList = action.payload;
      state.error = undefined;
      state.loadingAdministrationRules = false;
    },
    fetchFilterSettings(state, action) {
      state.settings = action.payload;
      state.error = undefined;
      state.loadingSettings = false;
    },
    updateFilterSettings(state, action) {
      state.settings = action.payload;
      state.error = undefined;
      state.loadingSettings = false;
    },
    fetchTableSettings(state, action) {
      state.settings = action.payload;
      state.error = undefined;
      state.loadingSettings = false;
    },
    updateTableSettings(state, action) {
      state.settings = action.payload;
      state.error = undefined;
      state.loadingSettings = false;
    },
  },
});

export const administrationActions = administrationSlice.actions;

export default administrationSlice.reducer;
